import { valueDataToStringsWithDelimiters } from "@smartsuite/automation-conditions";

import type {
  InputData,
  RecordJobData,
} from "@smartsuite/automation-engine-api";
import type { JobDetails } from "../ActivityDetails.types";

export const getInputValue = (
  input: InputData,
  jobDetails: JobDetails,
  recordJob?: RecordJobData,
): string => {
  if (input.value === undefined) {
    return "";
  }
  if (recordJob !== undefined) {
    if (recordJob.outputData?.recordList?.recordList !== undefined) {
      const output =
        recordJob.outputData.recordList.recordList.records[0]?.outputs.find(
          (output) => output.outputId === input.inputId,
        );

      if (output?.value !== undefined) {
        return valueDataToStringsWithDelimiters(
          output.value,
          jobDetails.job.automation?.timezone,
        ).join("; ");
      }
    }
    if (recordJob.outputData?.outputs !== undefined) {
      const output = recordJob.outputData.outputs.find(
        (output) => output.outputId === input.inputId,
      );

      if (output?.value !== undefined) {
        return valueDataToStringsWithDelimiters(
          output.value,
          jobDetails.job.automation?.timezone,
        ).join("; ");
      }
    }
  }
  return valueDataToStringsWithDelimiters(
    input.value,
    jobDetails.job.automation?.timezone,
  ).join("; ");
};
